import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { map } from 'rxjs/operators';
import { DialogData } from 'src/app/entities/dialogData';
import { TaxName } from 'src/app/entities/taxName';
import { CategoryService } from 'src/app/services/category.service';
import { DropdownService } from 'src/app/services/dropdown.service';
import { RevenueCodeService } from 'src/app/services/revenueCode.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxNameService } from 'src/app/services/taxName.service';
import { DialogCommunicator } from '../dialog-communicator';

@Component({
  selector: 'gov-tax-name-dialog',
  templateUrl: './tax-name-dialog.component.html',
  styleUrls: ['./tax-name-dialog.component.css']
})
export class TaxNameDialogComponent extends DialogCommunicator implements OnInit {

  text: string
  emitter: EventEmitter
  taxName = {}
  municipalities: any[]
  categories: any[]
  revenueCodes: any[]

  constructor(
    public dialogRef: MatDialogRef<TaxNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public sharedService: SharedService, public revenueCodeService: RevenueCodeService,
    public taxNameService: TaxNameService, public confirmationDialog: MatDialog, public dropdownService: DropdownService,
    public categoryService: CategoryService) {
    super(dialogRef, sharedService)
    this.setConfirmationDialog(this.confirmationDialog)
  }

  ngOnInit() {
    this.taxName = new TaxName()
    if (this.data) {
      this.taxNameService.getResource('tax-name', this.data['_id']).subscribe(val => {
        this.taxName = val
        this.taxName['class'] = 'TAX-NAME'
        this.setEntity(this.taxName);
        this.populateDropdowns()
      }
      )
    } else {
      this.setEntity(this.taxName);
      this.populateDropdowns()
    }

  }

  populateDropdowns(){
    this.dropdownService.getList('municipality').pipe(map(val => val.map(item => ({ name: item.name, id: item.id })))).subscribe((municipalities) => {
      this.municipalities = municipalities;
    });
    this.revenueCodeService.getList('revenue-code').subscribe((result) => {
      const revenueCodes = result.records || result;
      this.revenueCodes = revenueCodes.map(item => ({
        code: item.code,
        id: item.id,
        name: `${item.code} ${item.name}`
      }));
    });
    this.categoryService.getList("category").subscribe((result) => {
      this.categories = result.map(elem => { return { name: elem.name, id: elem.id, tinCode: elem.tinCode, taxPayerType: elem.taxPayerType } });;
    });
  }

  selectChangeMunicipality = (event: any) => {
    this.taxName['municipality'] = event.data;
  };
  selectChangeRevenueCode = (event: any) => {
    this.taxName['revenueCode'] = event.data;
  };
  selectChangeCategory = (event: any) => {
    this.taxName['category'] = event.data;
  };

}
